import { render, staticRenderFns } from "./SeatMatrix.vue?vue&type=template&id=1f7158a4&scoped=true&"
import script from "./SeatMatrix.vue?vue&type=script&lang=js&"
export * from "./SeatMatrix.vue?vue&type=script&lang=js&"
import style0 from "./SeatMatrix.vue?vue&type=style&index=0&id=1f7158a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7158a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileAction } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VIcon,VLayout,VList,VListTile,VListTileAction,VListTileContent,VListTileTitle,VSubheader})
